import React, { Component } from 'react';
import cx from '../../../styles';

class TooltipBehavior extends Component {

    constructor(props) {
        super(props);
        this.state = {isOpen: false};
    }

    componentDidMount(){
        this.setState({isOpen: this.props.isOpen});
        document.addEventListener("keydown", this.escHandler, false);
        document.addEventListener('mousedown', this.outsideClickHandler);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({isOpen: nextProps.isOpen});
    }

    componentWillUnmount(){
        document.removeEventListener("keydown", this.escHandler, false);
        document.addEventListener('mousedown', this.outsideClickHandler);
    }

    checkIfClosedCallback = () => {
        if(!this.state.isOpen) this.onPopoutClose();
    }

    closePopout = () => {
        this.setState({isOpen : false});
        this.props.onClose();
    }

    escHandler = (event) => {
        if(event.keyCode === 27) {
            this.closePopout();
        }
    }

    outsideClickHandler = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.closePopout();
        }
    }

    render() {
        return  (
            <div className={cx("tooltip-behavior")} ref={node=>this.wrapperRef=node}>
                {this.props.children}
            </div>
        );
    }

}

export default TooltipBehavior;